import Model from "../Model";

class VideowallTops extends Model{

    buildUrl ({ param }) {
        return ['/filters/getgroupvideowallfilter/', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new VideowallTops;